module.exports = __webpack_public_path__ + "7985432e00b24be9ccd59a1a4afb0aa2.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/show-note/show-note.html
// module id = 1068
// module chunks = 0